import Request from './request';

export default class CityHttpService {
    private static uri = 'erp/cities';

    public static get(data: any) {
        return Request.get(this.uri, data);
    }
}
